module.exports = __webpack_public_path__ + "img/logo-smartphone-id-sm.6615033d.png";